<template>
	<div class="h-full">
		<div class="flex items-center h-full">
			<div class="w-full grid justify-items-center">
				<panel :title="$t('eny.login')" :subtitle="$t('eny.loginMsg')" addclass='min-w-800 my-3'>
					<form id="user-register-form">
						<div class="flex flex-col items-center px-5">
							<div class="w-full grow pt-5">
								<!-- Firm data title -->
								<div class="flex flex-col items-center">
									<div class="w-full max-w-text">
										<p class="text-2xl pb-1 font-bold">{{$t('eny.firmdata')}}</p>
									</div>
								</div>
								<!-- Firm name -->
								<div class="flex flex-col items-center pt-1">
									<div class="w-full max-w-text">
										<ejs-maskedtextbox id="fname" name="fname" floatLabelType="Auto" disabled :placeholder="$t('eny.firmname')" v-model:value="firm.name"></ejs-maskedtextbox>
									</div>
								</div>
								<!-- Firm street & nr -->
								<div class="flex flex-col items-center pt-2">
									<div class="w-full max-w-text">
										<ejs-maskedtextbox id="faddress" name="faddress" floatLabelType="Auto" :placeholder="$t('eny.firmaddress')+$t('eny.required')" v-model:value="firm.street"></ejs-maskedtextbox>
									</div>
								</div>
								<!-- Firm zip/city -->
								<div class="flex flex-col items-center pt-2">
									<div class="w-full max-w-text flex gap-2">
										<div class="w-1/3">
											<ejs-maskedtextbox :change="handleChange" id="fzip" name="fzip" floatLabelType="Auto" :placeholder="$t('eny.zip')+$t('eny.required')" v-model:value="firm.zip"></ejs-maskedtextbox>
										</div>
										<div class="w-2/3" v-if="this.multipleCity === true">
											<ejs-combobox id='fcity' name='fcity' :dataSource='this.cities' :fields='cityFields' floatLabelType="Auto" :placeholder="$t('eny.city')+$t('eny.required')" :showClearButton="false" :allowCustom="false" v-model:value="firm.city"></ejs-combobox>
										</div>
										<div class="w-2/3" v-else>
											<ejs-maskedtextbox id="fcity" name="fcity" floatLabelType="Auto" :placeholder="$t('eny.city')+$t('eny.required')" v-model:value="firm.city"></ejs-maskedtextbox>
										</div>
									</div>
								</div>
								<!-- Firm phone number -->
								<div class="flex flex-col items-center pt-2">
									<div class="w-full max-w-text">
										<ejs-maskedtextbox id="ftelnr" name="ftelnr" floatLabelType="Auto" mask="000 000 00 00" :placeholder="$t('eny.phonenr')+$t('eny.required')" v-model:value="firm.phone"></ejs-maskedtextbox>
									</div>
								</div>
								<!-- User data title -->
								<div class="flex flex-col items-center pt-4">
									<div class="w-full max-w-text">
										<p class="text-2xl pb-1 font-bold">{{$t('eny.userdata')}}</p>
									</div>
								</div>
								<!-- User first name -->
								<div class="flex flex-col items-center">
									<div class="w-full max-w-text">
										<ejs-maskedtextbox id="ufirstname" name="ufirstname" floatLabelType="Auto" :placeholder="$t('eny.firstname')+$t('eny.required')" v-model:value="user.given_name"></ejs-maskedtextbox>
									</div>
								</div>
								<!-- User last name -->
								<div class="flex flex-col items-center pt-2">
									<div class="w-full max-w-text">
										<ejs-maskedtextbox id="ulastname" name="ulastname" floatLabelType="Auto" :placeholder="$t('eny.lastname')+$t('eny.required')" v-model:value="user.family_name"></ejs-maskedtextbox>
									</div>
								</div>
								<!-- User email -->
								<div class="flex flex-col items-center pt-2">
									<div class="w-full max-w-text">
										<validation><ejs-maskedtextbox id="uemail" name="uemail" floatLabelType="Auto" :placeholder="$t('eny.email')+$t('eny.required')" v-model:value="user.email"></ejs-maskedtextbox></validation>
									</div>
								</div>
								<!-- User phone -->
								<div class="flex flex-col items-center pt-2">
									<div class="w-full max-w-text">
										<ejs-maskedtextbox id="umobphone" name="umobphone" floatLabelType="Auto" mask="000 000 00 00" :placeholder="$t('eny.mobphone')+$t('eny.required')" v-model:value="user.phone"></ejs-maskedtextbox>
									</div>
								</div>
							</div>
							<div class="w-full px-10 md:px-20 pt-3 2xl:pt-6 flex flex-row justify-center">
								<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="onboarding">{{$t('eny.register')}}</button>
							</div>
						</div>
					</form>
				</panel>
			</div>
		</div>
	</div>
</template>
<script>
import { TextBoxComponent } from '@syncfusion/ej2-vue-inputs';
import { MaskedTextBoxComponent, FormValidator } from "@syncfusion/ej2-vue-inputs";
import Validation from "../Base/Validation.vue";
import Panel from "../Base/Panel.vue";
import useNotification from "../hooks/useNotification";
import { mapGetters } from 'vuex';
import axios from "axios";
import {ComboBoxComponent} from "@syncfusion/ej2-vue-dropdowns";

export default {
	name: "UserRegister",
	components: {
		'ejs-textbox': TextBoxComponent,
		"ejs-maskedtextbox": MaskedTextBoxComponent,
		'ejs-combobox': ComboBoxComponent,
		'panel': Panel,
		'validation': Validation,
	},
	setup() {
		const { notification, showNotification, hideNotification } = useNotification();
		return {
			notification,
			showNotification,
			hideNotification,
		}
	},
	data() {
		return {
			firm: {
				name: this.$route.params.firmname,
				uid: this.$route.params.uid,
				street: '',
				zip: '',
				city: '',
				phone: '',
			},
			user: {
				given_name: '',
				family_name: '',
				email: '',
				phone: '',
			},
			formObject: '',
			cityFields : { text: 'City', value: 'City' },
			zipCodes:{},
			multipleCity:false,
			cities:{},
		};
	},
	mounted() {
		var options = {
			rules: {
				uemail: { required: [true], email: [true, this.$t('eny.user_wrong_email_msg')]},
				faddress: { required: [true, this.$t('eny.field_empty')] },
				fzip: { required: [true, this.$t('eny.field_empty')], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				fcity: { required: [true, this.$t('eny.field_empty')] },
				ftelnr: { required: [true, this.$t('eny.field_empty')] },
				ufirstname: { required: [true, this.$t('eny.field_empty')] },
				ulastname: { required: [true, this.$t('eny.field_empty')] },
				umobphone: { required: [true, this.$t('eny.field_empty')] },
			},
			customPlacement: this.showValidationError,
			/*customPlacement: function(element, errorElement) {
				element.closest('.validation-group').querySelector('.error-element').appendChild(errorElement);
			},*/
		};
		// defines FormValidator to validate the TimePicker
		this.formObject = new FormValidator("#user-register-form", options);
		this.getZipMap();
	},
	methods: {
		getZipMap(){
			axios.get('/customer/getZipMap')
				.then((response) => {
					this.zipCodes = response.data;
				})
		},
		handleChange(e) {
			if (e.value.length === 4) {
				if (this.zipCodes[e.value]) {
					if (this.zipCodes[e.value].length!==undefined) {
						this.multipleCity = true;
						this.cities = this.zipCodes[e.value];
						this.firm.city = this.cities[0].City;
					}
					else {
						this.multipleCity = false;
						this.firm.city = this.zipCodes[e.value].City;
					}
				}
			} else {
				this.multipleCity = false;
				this.firm.city = "";
			}
		},
		onboarding: function() {
			if (this.formObject.validate()) {
				const data= {firm: this.firm, user: this.user};
				this.$store.dispatch('user/onboarding', data);
				this.hideNotification();
			}
		}
	},
	computed :{
		...mapGetters('user', ['loading', 'success', 'message']),
	},
	watch: {
		message(value, oldValue) {
			if (value!=='') {
				this.showNotification(value, this.success ? 'info ': 'error', 5);
				if (this.success) {
					this.$router.push('/registerConfirmation/');
				}
			}
		},
	}
}
</script>
